import React, { useEffect } from 'react';
import { X, Minus, Plus, ShoppingBag } from 'lucide-react';
import { useCartStore } from '../store/cart';
import { Link, useNavigate } from 'react-router-dom';
export function CartDrawer() {
  const navigate = useNavigate();
  const {
    items,
    isOpen,
    closeCart,
    removeItem,
    updateQuantity,
    totalPrice
  } = useCartStore();
  // Prevent body scroll when cart is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] transition-opacity" onClick={closeCart} aria-hidden="true" data-id="element-22" />

      {/* Drawer */}
      <div className="fixed inset-y-0 right-0 w-full sm:w-[400px] bg-vsc-bg border-l border-neutral-800 z-[101] flex flex-col shadow-2xl transform transition-transform duration-300 ease-in-out" data-id="element-23">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-neutral-800" data-id="element-24">
          <h2 className="font-display text-2xl tracking-wide flex items-center gap-2" data-id="element-25">
            <ShoppingBag size={24} data-id="element-26" />
            Your Cart
          </h2>
          <button onClick={closeCart} className="p-2 hover:text-vsc-gold transition-colors rounded-sm" aria-label="Close cart" data-id="element-27">
            <X size={24} data-id="element-28" />
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-29">
          {items.length === 0 ? <div className="h-full flex flex-col items-center justify-center text-neutral-400 space-y-4" data-id="element-30">
              <ShoppingBag size={48} className="opacity-20" data-id="element-31" />
              <p data-id="element-32">Your cart is empty.</p>
              <button onClick={closeCart} className="text-vsc-gold hover:text-white underline mt-4" data-id="element-33">
                Continue Shopping
              </button>
            </div> : <div className="space-y-6" data-id="element-34">
              {items.map(item => <div key={item.id} className="flex gap-4 bg-neutral-900/50 p-3 rounded-sm border border-neutral-800/50" data-id="element-35">
                  <div className="w-20 h-24 bg-neutral-800 rounded-sm overflow-hidden flex-shrink-0" data-id="element-36">
                    <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" data-id="element-37" />
                  </div>

                  <div className="flex-1 flex flex-col justify-between" data-id="element-38">
                    <div data-id="element-39">
                      <div className="flex justify-between items-start gap-2" data-id="element-40">
                        <h3 className="font-medium text-sm leading-tight" data-id="element-41">
                          {item.product.name}
                        </h3>
                        <button onClick={() => removeItem(item.id)} className="text-neutral-500 hover:text-red-400 transition-colors" aria-label="Remove item" data-id="element-42">
                          <X size={16} data-id="element-43" />
                        </button>
                      </div>
                      <p className="text-xs text-neutral-400 mt-1" data-id="element-44">
                        {item.color} / {item.size}
                      </p>
                    </div>

                    <div className="flex items-center justify-between mt-2" data-id="element-45">
                      <div className="flex items-center border border-neutral-700 rounded-sm" data-id="element-46">
                        <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-1 hover:bg-neutral-800 text-neutral-400 hover:text-white transition-colors" disabled={item.quantity <= 1} data-id="element-47">
                          <Minus size={14} data-id="element-48" />
                        </button>
                        <span className="w-8 text-center text-sm" data-id="element-49">
                          {item.quantity}
                        </span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-1 hover:bg-neutral-800 text-neutral-400 hover:text-white transition-colors" data-id="element-50">
                          <Plus size={14} data-id="element-51" />
                        </button>
                      </div>
                      <p className="font-medium" data-id="element-52">
                        ${item.product.price * item.quantity}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>}
        </div>

        {/* Footer */}
        {items.length > 0 && <div className="p-6 border-t border-neutral-800 bg-neutral-900/30" data-id="element-53">
            <div className="flex justify-between items-center mb-6" data-id="element-54">
              <span className="text-neutral-400" data-id="element-55">Subtotal</span>
              <span className="font-display text-2xl" data-id="element-56">${totalPrice()}</span>
            </div>
            <p className="text-xs text-neutral-500 mb-4" data-id="element-57">
              Shipping and taxes calculated at checkout.
            </p>
            <button onClick={() => {
          closeCart();
          navigate('/checkout');
        }} className="w-full bg-vsc-gold text-black font-medium py-4 hover:bg-white transition-colors rounded-sm text-lg" data-id="element-58">
              Checkout
            </button>
          </div>}
      </div>
    </>;
}